// extracted by mini-css-extract-plugin
export default {"Container":"BasicModal_Container__35VnX"};